<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
</script>
<template>
  <span
    size="xs"
    class="tw-block tw-size-4 tw-rounded-full tw-bg-gp-orange tw-py-0.5 tw-text-center"
  >
    <FontAwesomeIcon
      :icon="['fas', 'fa-eye']"
      class="tw-inline-block tw-h-3 tw-align-top tw-text-sm tw-text-black"
    />
  </span>
</template>
